var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{class:['spl-label', {'spl-label-inline': _vm.inline}, {'spl-label-dark': _vm.dark}]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }